
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/speakers/profile/[slug]",
      function () {
        return require("private-next-pages/speakers/profile/[slug].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/speakers/profile/[slug]"])
      });
    }
  